import React from 'react';
import { useTranslation } from 'react-i18next';
import { WarningIcon } from '@components-library/Icons/iconsComponents';
import { IInvestors, IMaster } from '@components-member/socialTrading/social.interfaces';
import CONSTANTS from '@components-shared/constants';
import { NotificationMessage } from '@components-shared/notification';
import { INotificationWarning } from '@components-shared/shared.interfaces';
import { getDefaultLocale } from '@locales/helpers';
import { keyMap } from '@locales/lokalise/keyMap';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';

interface IOptionNotificationProps {
  investorAccount?: IInvestors;
  notificationsWarning: INotificationWarning;
  masterAccount: IMaster;
}

export const OptionNotification = observer((props: IOptionNotificationProps): JSX.Element | null => {
  const { i18n } = useTranslation();
  const { masterAccount, notificationsWarning } = props;
  const { warningsInLanguages, showWarning } = notificationsWarning;
  const currentLanguage = i18n.language;
  const defaultLanguage = getDefaultLocale();

  const masterCountry = masterAccount.country;
  const { accountStore } = useMobxStore();
  const investorCountry = accountStore.userProfile.profile.country;
  const warningMessageAvailable = showWarning && investorCountry !== masterCountry;

  const getWarningMessageInLanguage = () => {
    for (const language in warningsInLanguages) {
      if (currentLanguage === language) {
        return warningsInLanguages[language].text;
      }
    }

    return getDefaultWarningMessage();
  };

  const getDefaultWarningMessage = () => {
    if (!warningsInLanguages[defaultLanguage]) {
      return null;
    }

    return warningsInLanguages[defaultLanguage].text;
  };

  const message = getWarningMessageInLanguage();

  const listItems = warningMessageAvailable && message ? [message] : null;

  if (!listItems) {
    return null;
  }

  return (
    <NotificationMessage
      title={keyMap.socialTradingModalWarning}
      type={CONSTANTS.NOTIFICATION_TYPE.WARNING}
      useRollUp={false}
      listItems={listItems}
      icon={<WarningIcon size="inherit" />}
    />
  );
});
